
import {
  defineComponent,
  onMounted,
  ref,
  computed,
  reactive,
  watch,
} from "vue";
import contacts from "@/core/data/contacts";
import MessageIn from "@/components/messenger-parts/MessageIn.vue";
import MessageOut from "@/components/messenger-parts/MessageOut.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { statusColor } from "@/core/services/HelpersFun";
import UserInfo from "@/core/services/UserInfo";
import UserAvatar from "@/components/UserAvatar.vue";
import { useI18n } from "vue-i18n";
import Emoji from "@/components/Emoji.vue";

import { Conversations } from "@/store/pinia/Conversations";
import { storeToRefs } from "pinia";
import Status from "@/components/Status.vue";

export default defineComponent({
  name: "kt-customer-live-chat-page",
  components: {
    Status,
    MessageIn,
    MessageOut,
    UserAvatar,
    Emoji,
  },
  setup() {
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) return t(text);
      return text;
    };

    const messagesRef = ref<null | HTMLElement>(null);
    const messagesInRef = ref<null | HTMLElement>(null);
    const messagesOutRef = ref<null | HTMLElement>(null);

    const conversationsHolder = Conversations();
    const {
      fetchConversationBody,
      setLastMessageIdNull,
      saveNewMessage,
      setFilterConversation,
      closeConversation,
    } = conversationsHolder;

    const {
      unReadConversation,
      conversationsList,
      loadingConversations,
      loadingConversationBody,
      conversationBody,
      activeConversation,
      lastMessageId,
      targetConversationId,
    } = storeToRefs(conversationsHolder);

    const filter = ref({
      status: false,
      search: "",
    });

    watch(filter.value, () => {
      setFilterConversation(filter.value.search, filter.value.status);
    });

    const user = UserInfo.getUser();

    const file = ref();
    const newMessage = reactive({
      text: "",
      fileInputKey: 0,
      activeBox: true,
    });

    const submitButton = ref<HTMLButtonElement | null>(null);

    const addNewMessage = async () => {
      if (!newMessage.text && !file.value.files[0]) return;

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // send message
      const formData = new FormData();
      if (file.value.files[0]) formData.append("file", file.value.files[0]);
      if (newMessage.text) formData.append("message", newMessage.text);
      formData.append("conversation_id", targetConversationId.value);

      const res = await saveNewMessage(formData);

      if (res === true) {
        newMessage.text = "";
        ++newMessage.fileInputKey;
      }

      if (submitButton.value) {
        //Deactivate indicator
        submitButton.value?.removeAttribute("data-kt-indicator");
        // eslint-disable-next-line
        submitButton.value!.disabled = false;
        if (messagesRef.value) {
          messagesRef.value.scrollTop = messagesRef.value.scrollHeight;
        }
      }
    };

    const mobileUiChat = computed(() => {
      return window.innerWidth < 992;
    });

    onMounted(() => {
      setCurrentPageBreadcrumbs("پشتیبانی", ["گفتگو"]);

      // Detect when scrolled to bottom.
      const listElm = document.querySelector("#kt_chat_scroll_admin");
      if (listElm) {
        listElm.addEventListener("scroll", (e) => {
          if (
            listElm.clientHeight + -listElm.scrollTop + 2 >=
            listElm.scrollHeight
          ) {
            if (lastMessageId.value !== undefined) {
              fetchConversationBody(targetConversationId.value);
            }
          }
        });
      }
    });

    const addEmoji = (emoji) => {
      newMessage.text += emoji;
    };

    return {
      messagesOutRef,
      messagesRef,
      messagesInRef,

      loadingConversations,
      loadingConversationBody,
      conversationBody,
      setLastMessageIdNull,

      fetchConversationBody,

      addNewMessage,
      contacts,

      statusColor,
      translate,
      user,
      activeConversation,
      lastMessageId,

      mobileUiChat,
      submitButton,

      conversationsList,
      newMessage,
      targetConversationId,
      file,

      unReadConversation,
      filter,
      closeConversation,
      addEmoji,
    };
  },
});
